// Library Imports
import store, { RootState } from 'store';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { Popover, Tooltip, Typography } from 'antd';

// Local Imports
import Checkbox from '../../Common/Components/Checkbox';
import Speed from '../../../assets/img/icons/Speed.svg';
import Elipsis from '../../../assets/img/VerticleElipsis.png';
import Profile from '../../../assets/img/icons/ArticlePopover/lowerList/profile.svg';
import { ReactComponent as Mail } from '../../../assets/img/icons/mail.svg';
import { ReactComponent as Analytics } from '../../../assets/svgs/AnalyticsUpdatedIcon.svg';
import { ReactComponent as Click } from '../../../assets/img/icons/Click.svg';
import { ReactComponent as Send } from '../../../assets/img/icons/SendingWhite.svg';
import { ReactComponent as Eye } from '../../../assets/img/icons/eye.svg';
import { ReactComponent as RemoveAud } from '../../../assets/img/remove-aud-list.svg';
import { IContactItem } from '../Audience/interface';
import { AUDIENCE_LISTS_DETAILS, DEFAULT_CAMPAIGN_IMAGE } from '../../../constants/types';
import { removeOnClickBubble } from 'utils';
import { getContactDashboard, getContactDetails, getContactEngagement, getContactSimilar, getContactSubscriptions } from '../Audience/actions';
import { openDetailProfile, openOverlay } from 'modules/GlobalActions';
import { CAMPAIGN_AUDIENCE, PEOPLE_AUDIENCE } from 'constants/actionTypes';

const UserPopoverTitle = (
  <div className="padding-top-sm padding-bottom-sm padding-right-md">
    <h4 className="mb-0">Edit Contact</h4>
  </div>
);

const UserPopoverContent = (setShowEditContactPopover: any) => (
  <div className="BlogItemDropdown">
    <ul className="me-4">
      <li className="d-flex mb-1 cursor-pointer" onClick={() => editContactHandler(setShowEditContactPopover)}>
        <img src={Profile} alt="" /> &nbsp;&nbsp;Contact details
      </li>
    </ul>
  </div>
);

const editContactPopoupAction = (state: boolean) => {
  store.dispatch({
    type: CAMPAIGN_AUDIENCE.SET_EDIT_CONTACT_POPOVER_STATE,
    payload: { editContactPopup: state },
  });
};

const editContactHandler = (setShowEditContactPopover: (arg: boolean) => void) => {
  setShowEditContactPopover(false);
  store.dispatch({
    type: PEOPLE_AUDIENCE.RESET_EDIT_CONTACT,
  });
  store.dispatch({
    type: PEOPLE_AUDIENCE.OPEN_EDIT_CONTACT_SIDEBAR,
  });
  editContactPopoupAction(false);
  openOverlay();
};

interface IUserListItemProps {
  contact: IContactItem;
  hideIcons?: boolean;
  hideEllipsesMenu?: boolean;
  isChecked?: boolean;
  selectAll?: boolean;
  onClickChecked?: (value: any) => void;
  isProfiled?: boolean;
  deleteAllFlag?: boolean;
  contactCheckHandler?: (id: string, isChecked: boolean) => void;
  handleReselectItem?: (id: string) => void;
  status: string;
  index: number;
  tabStateSearch?: boolean;
  handleRemoveSingleContact?: (args: { flag: boolean; name: string; contact_id: number | string }) => void;
  isFirefox?: boolean;
  isSafari?: boolean;
  hideEngagement?: boolean;
}

const UserListItem: React.FC<IUserListItemProps> = (props) => {
  // Local States
  const {
    contact,
    isChecked,
    hideIcons,
    onClickChecked,
    selectAll,
    index,
    tabStateSearch,
    handleRemoveSingleContact,
    isFirefox,
    isSafari,
    hideEngagement,
  } = props;
  const { Paragraph } = Typography;
  const [showEditContactPopover, setShowEditContactPopover] = useState(false);
  const [deleteInProgressState, setdeleteInProgressState] = useState(false);
  const [newlyAddedContact, setNewlyAddedContact] = useState(false);

  // Redux States
  const editContactPopup: boolean = useSelector((state: RootState) => state.audience.editContactPopup);
  const importListAsider: boolean = useSelector((state: RootState) => state.audience.importListAsider);
  const showDetailProfile: boolean = useSelector((state: RootState) => state.audience.showDetailProfile);
  const linkAsider: boolean = useSelector((state: RootState) => state.audience.linkAsider);
  const deleteInProgress: boolean = useSelector((state: RootState) => state.audienceListDetails.delete.loading);
  const contactAddedInList: boolean = useSelector((state: RootState) => state.audienceListDetails.contactAddedInList);
  const contactsAddedToList = useSelector((state: RootState) => state.audienceListDetails.contactsAddedToList);
  const activeList = useSelector((state: RootState) => state.peopleAudience.currentActiveList);

  const [ellipsisName, setEllipsisName] = useState(false);
  const [ellipsisEmail, setEllipsisEmail] = useState(false);
  const [ellipsisDesignation, setEllipsisDesignation] = useState(false);
  const [ellipsisCompany, setEllipsisCompany] = useState(false);

  // Component Logic
  useEffect(() => {
    if (contactAddedInList) {
      setNewlyAddedContact(true);
      setTimeout(() => {
        setNewlyAddedContact(false);
      }, 4000);
      store.dispatch({
        type: AUDIENCE_LISTS_DETAILS.RESET_NEWLY_ADDED_CONTACT,
      });
    }
  }, [contactAddedInList]);

  // When new contact added to List through "Add Contact"
  useEffect(() => {
    if (contactsAddedToList.length > 0) {
      setNewlyAddedContact(true);
      setTimeout(() => {
        setNewlyAddedContact(false);
      }, 4000);
    }
  }, [contactsAddedToList]);

  const editContactPopoupAction = (state: boolean) => {
    store.dispatch({
      type: CAMPAIGN_AUDIENCE.SET_EDIT_CONTACT_POPOVER_STATE,
      payload: { editContactPopup: state },
    });
  };

  useEffect(() => {
    setdeleteInProgressState(deleteInProgress);
  }, [deleteInProgress]);

  useEffect(() => {
    if (isChecked) {
      setShowEditContactPopover(false);
      editContactPopoupAction(false);
    }
    if (showDetailProfile) {
      setShowEditContactPopover(false);
      editContactPopoupAction(false);
    }
    if (importListAsider) {
      setShowEditContactPopover(false);
      editContactPopoupAction(false);
    }
    if (linkAsider) {
      setShowEditContactPopover(false);
      editContactPopoupAction(false);
    }
  }, [isChecked, importListAsider, showDetailProfile, linkAsider]);

  const ellipsisHandler = () => {
    if (!editContactPopup && !showEditContactPopover) {
      editContactPopoupAction(true);
      setShowEditContactPopover(true);
      getContactDetails(contactId);
    } else {
      editContactPopoupAction(false);
      setShowEditContactPopover(false);
    }
  };

  const contactId = contact?.id?.toString();

  const UserContactListItemClickHandler = () => {
    openDetailProfile();
    getContactDetails(contactId);
    getContactDashboard(contactId);
    getContactSubscriptions(contactId);
    getContactEngagement(contactId);
    getContactSimilar(contactId);
  };

  useEffect(() => {
    if (!editContactPopup) setShowEditContactPopover(false);
  }, [editContactPopup]);

  const name = contact?.name?.trim() || contact?.email;

  const onClickRemoveContact = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    handleRemoveSingleContact && handleRemoveSingleContact({ flag: true, contact_id: contactId, name });
  };

  const checkCurrentActiveList = () => {
    if (activeList === 'list' || activeList === '') return false;
    return true;
  };

  /* Toggle class "active", "active-new" and "drag-active"  on tr for checked items */
  return (
    <Styledtr
      onClick={UserContactListItemClickHandler}
      className={`table-style ${isChecked || selectAll ? 'active-new' : 'active qa-tr-active'} ${
        newlyAddedContact && index === 0 ? 'active-new' : ''
      } ${deleteInProgressState ? 'disable' : ''} ${isFirefox ? 'firefox-before' : ''} ${isSafari ? 'safari-before' : ''}`}
      data-id="qa-list-table-tr"
    >
      <td className={`${checkCurrentActiveList() && 'disable'} checkbox`}>
        <Checkbox
          onClick={() => {
            if (props.deleteAllFlag && isChecked && props?.contactCheckHandler) props?.contactCheckHandler(contactId, isChecked);
            else if (props?.handleReselectItem && props.deleteAllFlag) props?.handleReselectItem(contactId);
          }}
          checked={isChecked || selectAll || false}
          onChange={onClickChecked}
          data-id="qa-checkbox-row"
        />
      </td>
      <td>
        <span
          className="profile-img-wrapper"
          style={{
            borderColor: contact?.color ? contact.color : '#ffffff',
            backgroundColor: contact?.color ? contact.color : '#ffffff',
          }}
        >
          <img src={contact?.thumbnail || DEFAULT_CAMPAIGN_IMAGE} className="profile-img" alt="" />
        </span>
        <div className="profile">
          <div className="hidden-contact-name">
            {contact?.name?.trim() === '' || contact?.name === null || contact?.name === undefined ? contact?.email : contact?.name}
          </div>
          <Tooltip placement="topLeft" title={ellipsisName ? contact?.name : undefined}>
            <Paragraph ellipsis={{ rows: 1, onEllipsis: setEllipsisName }} className="name">
              {name}
            </Paragraph>
          </Tooltip>

          <Tooltip placement="topLeft" title={ellipsisEmail ? contact?.email : undefined}>
            <Paragraph ellipsis={{ rows: 1, onEllipsis: setEllipsisEmail }} className="email">
              {contact?.email}
            </Paragraph>
          </Tooltip>

          <Tooltip placement="topLeft" title={ellipsisDesignation ? contact?.designation : undefined}>
            <Paragraph ellipsis={{ rows: 1, onEllipsis: setEllipsisDesignation }} className="email designation">
              {contact?.designation && contact?.designation.length > 0 ? contact?.designation : ''}
            </Paragraph>
          </Tooltip>
        </div>
      </td>
      <td>
        <strong data-qa="qa-orgainization">
          <Tooltip placement="topLeft" title={ellipsisCompany ? contact?.organization : undefined}>
            <Paragraph ellipsis={{ rows: 1, onEllipsis: setEllipsisCompany }} className="organization company">
              {contact?.organization}
            </Paragraph>
          </Tooltip>
        </strong>
      </td>
      <td>
        <strong className="personality d-flex align-items-center" data-qa="qa-orgainization-one">
          <Circle color={contact?.color ? contact.color : 'black'} />
          {contact?.personality ? contact?.personality : 'N/A'}
        </strong>
      </td>
      <td>
        <strong
          className={`status d-flex align-items-center ${
            props?.status === 'Subscribed' ? 'status-style-sub' : props?.status === 'Unsubscribed' ? 'status-style-unsub' : 'status-style-bounce'
          }`}
        >
          {props?.status}
        </strong>
      </td>
      {!window.location.pathname.includes('campaigns') && !tabStateSearch && <td></td>}

      {hideIcons ? null : (
        <td className="actions-td d-flex justify-content-end align-items-center">
          <div className="actions">
            <ul>
              <li>
                <Tooltip placement="topLeft" title="Emails Sent">
                  <a>
                    <Send />
                    <span>{contact?.totalSent}</span>
                  </a>
                </Tooltip>
              </li>
              <li>
                <Tooltip placement="topLeft" title="Emails Delivered">
                  <a>
                    <Mail />
                    <span>{contact?.totalDelivery}</span>
                  </a>
                </Tooltip>
              </li>
              <li>
                <Tooltip placement="topLeft" title="Total Opens">
                  <a>
                    <Eye />
                    <span>{contact?.totalOpens}</span>
                  </a>
                </Tooltip>
              </li>
              <li>
                <Tooltip placement="topLeft" title="Total Clicks">
                  <a>
                    <Click />
                    <span>{contact?.totalClicks}</span>
                  </a>
                </Tooltip>
              </li>
              <li>
                <Tooltip placement="topLeft" title="Analytics">
                  <a
                    style={{ margin: '7px auto' }}
                    onClick={(e: any) => e.stopPropagation()}
                    className="analytics-icon"
                    href={`/analytics/contacts/dashboard/?contact_id=${contact?.id}`}
                    target="_blank"
                  >
                    <Analytics />
                  </a>
                </Tooltip>
              </li>
            </ul>
          </div>
        </td>
      )}

      {!hideEngagement &&
        (tabStateSearch ? (
          <td className="last-item">
            <div className="user-aud-area">
              <div className="engagement">
                <img src={Speed} alt="" />
                &nbsp;
                {contact?.engagementScore ?? 0}
              </div>
              <div className="aud-action" onClick={onClickRemoveContact}>
                <RemoveAud />
              </div>
            </div>
          </td>
        ) : (
          <td className="last-item">
            <div className="engagement">
              <img src={Speed} alt="" />
              &nbsp;
              {contact?.engagementScore ?? 0}
            </div>
          </td>
        ))}
      {tabStateSearch ? null : (
        <td onClick={removeOnClickBubble}>
          <Popover
            title={UserPopoverTitle}
            content={UserPopoverContent(setShowEditContactPopover)}
            overlayClassName="BlogPopover"
            placement="leftTop"
            trigger="click"
            visible={showEditContactPopover}
            getPopupContainer={() => document.querySelectorAll('.audience-content-inner')[0] as HTMLElement}
          >
            <EllipsisSpan className={`${isChecked ? 'disable' : ''}`} onClick={ellipsisHandler}>
              <img src={Elipsis} alt="" />
            </EllipsisSpan>
          </Popover>
        </td>
      )}
    </Styledtr>
  );
};

export default UserListItem;

const Styledtr = styled.tr`
  box-shadow: 0px 0px 16.875px -1.406px rgba(0, 0, 0, 0.08);
  .disable {
    pointer-events: none;
    opacity: 0.5;
  }
  :hover {
    cursor: pointer;
  }
`;

const Circle = styled.div<{ color: string }>`
  width: 10px;
  height: 10px;
  background: ${(props) => props.color};
  border-radius: 50%;
  margin-right: 3px;
`;

const EllipsisSpan = styled.span`
  padding: 3px;
  position: relative;
  z-index: 0;
  margin-right: 5px;
  cursor: pointer;
  &.disable {
    pointer-events: none;
    opacity: 0.5;
  }
`;
